import { render, staticRenderFns } from "./SecondaryInheritance.vue?vue&type=template&id=3f60ead0&"
import script from "./SecondaryInheritance.vue?vue&type=script&lang=js&"
export * from "./SecondaryInheritance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports